export default [
	'pages',
	'posts'
];
